// extracted by mini-css-extract-plugin
export var deleteIcon = "_r2-5";
export var deleteOption = "_r2-3";
export var divider = "_r2-2";
export var downloadIcon = "_r2-4";
export var drawer = "_r2-0";
export var drawerFooter = "_r2-6";
export var drawerOpen = "_r2-1";
export var highlighted = "_r2-7";
export var lighterHighlight = "_r2-8";